<h3 mat-dialog-title>Responder Atividade</h3>
<div mat-dialog-content>

    <div fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Cliente Aceitou?</mat-label>
            <mat-select 
                placeholder="Cliente Aceitou?"
                [(value)]="model.cliente_aceitou"
                [formControl]="cliente_aceitou"
                name="cliente_aceitou"                
            >
                <mat-option value="">SELECIONE</mat-option>
                <mat-option [value]="true">SIM</mat-option>
                <mat-option [value]="false">NÃO</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Valor </mat-label>
            <input 
                matInput 
                placeholder="R$ 0,00" 
                [formControl]="valor" 
                maxlength="255" 
                currencyMask 
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
            />            
        </mat-form-field>
    </div>
    
    <div fxLayout="row wrap">
        <mat-form-field style="width: 100%" appearance="outline">
            <mat-label>Observação</mat-label>
            <textarea
                matInput 
                placeholder="Observação" 
                [formControl]="observacao"
                required
                [rows]="5">
            </textarea>
        </mat-form-field>
    </div>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">
        Salvar
    </button>
</div>